import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";

// Stable per-tab session id for grouping search analytics.
let SESSION_ID = null;
const sessionId = () => {
  if (SESSION_ID) return SESSION_ID;
  try {
    const key = "abay_search_session";
    SESSION_ID = sessionStorage.getItem(key);
    if (!SESSION_ID) {
      SESSION_ID = (crypto?.randomUUID?.() || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`);
      sessionStorage.setItem(key, SESSION_ID);
    }
  } catch {
    SESSION_ID = `s_${Date.now()}`;
  }
  return SESSION_ID;
};

/**
 * Search analytics — writes to the `search_events` table (migration 0009).
 * Fire-and-forget: never throws to the caller, never blocks the UI.
 * Not exposed publicly (RLS: users read own, admins read all).
 */
export const searchEventService = {
  record: ({ userId = null, query = "", filters = {}, resultsCount = null, clickedPropertyId = null, meta = {} } = {}) =>
    guard("searchEvent.record", async () => {
      const s = requireSupabase();
      const payload = {
        user_id: userId,
        query: query || null,
        filters: { ...filters, ...(Object.keys(meta).length ? { _meta: meta } : {}) },
        results_count: resultsCount,
        clicked_property_id: clickedPropertyId,
        session_id: sessionId(),
      };
      const { error } = await s.from("search_events").insert(payload);
      if (error) throw error;
      return true;
    }).catch(() => false), // analytics must never break search

  // Log that a user clicked a listing from a search (best-effort).
  recordClick: (userId, propertyId, query = "") =>
    searchEventService.record({ userId, query, clickedPropertyId: propertyId, meta: { type: "click" } }),
};
